export default {
  banner: {
    title: "汽车行业解决方案",
    subtitle:
      "深耕汽车制造、轮胎、零部件等上下游相关产业链，对内建设统一身份管理安全体系，对外管控上下游供应商与终端用户，实现汽车行业数字化转型。",
  },
  marquee: {
    item1: {
      title1: "丰田汽车",
      desc1:
        "世界十大汽车工业公司之一，也是日本最大的汽车公司。近三年稳坐全球销量冠军。",
      title2: "基于统一管理细化权限分配",
      desc2:
        "Authing 提供的统一身份管理基础设施，使我们能更安全高效地管理账号密码和员工访问权限。此外，Authing 的云原生架构支持弹性伸缩，能够应未来的需求，支撑业务扩张。",
    },
    item2: {
      title1: "四维图新",
      desc1:
        "中国导航地图、动态交通信息、位置大数据及乘用车等定制化车联网解决方案领导者。",
      title2: "基于身份底座强化认证安全",
      desc2:
        "企业高速发展，系统间的身份数据越发分散，不仅登录不便、更带来安全隐患。通过 Authing 构建的身份底座，我们得以在多应用间统一管理、自动化同步身份信息，在提效的同时强化安全性。",
    },
    item3: {
      title1: "某全球头部汽车生产商",
      desc1: "世界四大汽车生产商之一，在中国汽车销售榜上年年名列前茅。",
      title2: "基于联邦认证提高开发效率",
      desc2:
        "Authing 的联邦认证能力可以快速联合不同身份提供商，实现身份认证，从而大大提高内外部身份管理的效率，减少开发和运维的成本，节省宝贵的时间和资源。",
    },
    item4: {
      title1: "某 Tier 1 零部件制造商",
      desc1:
        "从属于全球五大汽车零部件供应商之一，业务遍布亚洲、欧洲、中东以及非洲。",
      title2: "基于 API 调用身份认证管理能力",
      desc2:
        "Authing 产品的 API 覆盖率高，支持主流语言的 SDK，使我们能便捷地调用用户管理、授权认证的 SDK，减少开发成本。而云原生的底层架构，能稳定支撑我们数十万用户的使用。",
    },
  },
  question: {
    title: "新能源造车势力崛起，身份管理升级刻不容缓",
    cardOne: {
      title: "权限管理薄弱，图纸机密泄漏风险大",
      descli1:
        "新能源势力快速发展，行业内人才流动率提升。各新老业务系统权限管理分散、多套并行、缺乏统一的策略，可能造成关键技术及数据信息的泄漏。",
      descli2:
        "权限管理的业务逻辑复杂，自研系统需投入大量研发成本；若未来根据业务需求进行扩展，还需进行重复建设，ROI 较低。",
    },
    cardTwo: {
      title: "子品牌与供应商数据复杂",
      descli1:
        "子品牌数据隔离难：成熟车企往往分设多个子品牌，不同子品牌的身份和数据应做数据隔离，以达到精细化管理的目的。",
      descli2:
        "供应商访问管理难：汽车制造产业链复杂，上下游供应商较多，而供应商相关的身份认证和访问权限等，同样需要妥善维护——但这将增加内部 IT 额外的管理成本。",
    },
    cardThree: {
      title: "AD 域短板日渐显著",
      descli1: "AD 价格高、操作复杂，对企业预算及人力要求较高；",
      descli2: "协议支持单一，兼容性弱，无法兼容新兴云上应用；",
      descli3:
        "AD 需与 HR、OA 等系统同步打通，实现统一的组织架构，避免管理员工重复维护，但自研需投入大量时间和人力",
    },
    cardFour: {
      title: "身份及数据割裂，车企数字化转型难落地",
      descli1:
        "数据分散：由于身份割裂，A 应用中的人员无法与 B 应用一一对应，数据难以互通整合、数字化转型困难。",
      descli2:
        "应用多：员工使用不同业务系统时，需进行多次认证，账号统一困难、操作效率低。",
      descli3:
        "人员多：员工入转调离频繁，并涉及大量编外人员，运维效率差，且可能有漏关权限的风险。",
    },
  },
  advantage: {
    item1: {
      title: "打造细粒度权限管理，保护关键造车机密",
      desc:
        "Authing 提供 RBAC、ABAC、NGAC 等权限管理模型，帮助企业针对不同场景，建立合适的权限控制策略。开发人员仅需接入 API/SDK，即可高效实现权限管理；还能通过 Pipeline 和 Webhook 等扩展能力，动态调整员工访问权限。",
      alt: "",
    },
    item2: {
      title: "统管上下游伙伴及子品牌身份，提升运维效率",
      desc:
        "基于「用户组」或「多租户」架构，可以有效地管理外部供应商、子品牌、下属 4s 店等人员的身份，从而提升车企信息化的效率。此外，各供应商能自行维护本租户内的人员权限，以建立内外部统一的身份基座。",
      alt: "",
    },
    item3: {
      title: "补全 AD 域短板，支撑企业业务扩张",
      desc:
        "自动化实现 Windows AD 身份目录同步及 OU 组信息同步，帮助企业解耦 AD 系统认证的负担，Authing 支持 OIDC、SAML、Oauth、CAS、LDAP 等标准协议，可覆盖 AD 对 B/S 系统的完整解决方案，为企业提升扩展性、便捷性。",
      alt: "",
    },
    item4: {
      title: "单点登录+自动化同步，让数据集中流转",
      desc:
        "Authing 预集成了 2000+ 海内外常见应用，能帮助企业高效实现单点登录，建立统一身份认证，多个系统帐号「一处管理、处处同步」，为不断扩张的汽车制造行业打下数据互通的基础。",
      alt: "",
    },
  },
  productivity: {
    title: "选择高安全、高性能、高生产力的身份产品",
    item1: {
      title: "高安全",
      desc1:
        "数据存储使用 AES-256 算法加密；通过 SSL/TLS 协议加密传输；使用 KMS 管理密钥，密钥定期轮换。",
      desc2: "7x24 小时的安全应急响应；两地三中心备份，保证灾难时快速恢复。",
      desc3: "ISO、等保三级、数据保护条例等多项认证。",
    },
    item2: {
      title: "高性能",
      desc1:
        " 云原生：采用 Kubernetes 容器化技术，支持分钟级别弹性扩容，最大可支持亿级别用户认证访问场景。",
      desc2: "云中立：最大程度兼容用户的云环境，不被原有的云厂商捆绑。",
    },
    item3: {
      title: "高生产力",
      desc1: " 开发者友好：提供丰富登录、认证、授权 API/SDK，降低研发成本。",
      desc2: "快速集成 2000+ 主流应用，简单、高效的建立身份中台。",
    },
  },
};
